export default [
  'OrgRestService',
  function (OrgRestService) {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        ngModel.$asyncValidators.innExists = function (modelValue) {
          if (!modelValue) {
            return Promise.resolve(); // Пропускаем пустые значения
          }
          return OrgRestService.exists({
            filters: `'inn' EQ '${modelValue}'`,
          }).$promise.then((response) => {
            if (response._embedded) {
              return Promise.reject(); // ИНН не найден
            } else {
              return Promise.resolve(); // ИНН существует
            }
          });
        };
      },
    };
  },
];
